import React, { Component } from 'react';
import FilterTypeDropdown from './FilterTypeDropdown.js';
import EffectParameterSlider from './EffectParameterSlider.js';

class FilterEffect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterEffect: props.filterEffect,
            refined: false,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        this.state.filterEffect = nextProps.filterEffect;
        return true;
    }

    handleOptionChange(evt) {
        document.activeElement.blur()
        if (evt.target.value === 'lowpass') {
            this.state.filterEffect.lowpass();
        } else {
            this.state.filterEffect.hipass();
        }
        this.setState(this.state);
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.state.filterEffect.isEnabled();
    }

    onChangeRefined(val) {
        this.setState({refined: val === 'refined'});
    }

    render() {
        var type = this.state.filterEffect.type;
        let className = this.props.automation !== undefined ?
            'enabled effect effect-automation' :
            this.state.filterEffect.isEnabled() ? 'effect enabled' :
            'effect disabled';
        let max = this.state.refined ? 400 : 10000;

        return (
            <div>
              {!this.isEnabled() ? '' :
              <div>
                    <FilterTypeDropdown effect={this.props.filterEffect}/>
                        <div className="clear-fix"/>
                 <EffectParameterSlider
                        customClassName={'wider-slider'}
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        selectedParameter={this.props.selectedParameter}
                        name='Cutoff'
                        lfoEnabled={true}
                        root={2}
                        sequencerEngine={this.props.sequencerEngine}
                        unit={'HZ'}
                        parameter={this.state.filterEffect.cutoffParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={1}
                        max={max}
                        min={20}
                        />
                   <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                         automation={this.props.automation}
                         selectedParameter={this.props.selectedParameter}
                   root={2}
                         name='Q'
                         lfoEnabled={true}
                         sequencerEngine={this.props.sequencerEngine}
                         parameter={this.state.filterEffect.qParameter}
                         onParameterChanged={this.props.onParameterChanged}
                         isParameter={true}
                         step={0.01}
                         max={10}
                         min={0}
                        />
                       <div className="">
                      <label>
                        <input 
                               type="checkbox"
                              value={this.state.refined ? 'unrefined' : 'refined'}
                               checked={this.state.refined}
                               onChange={(e) => this.onChangeRefined(e.target.value)} />
                          Refine
                      </label>
                    </div>
              
                  </div>
                  }
            </div>
        );
    }
}

export default FilterEffect;
